/**
 * Locale Interceptor
 * Автоматическое добавление заголовка user-locale для получения локализованного контента
 */
import type { AxiosInstance, InternalAxiosRequestConfig } from 'axios'
import { i18n } from '@/i18n'

export function setupLocaleInterceptor(axiosInstance: AxiosInstance) {
  // Request interceptor - добавление заголовка user-locale
  axiosInstance.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      // Получаем текущую локаль из i18n
      const global = i18n.global as unknown as { locale: { value: string } }
      const currentLocale = global.locale.value

      if (currentLocale && config.headers) {
        // Добавляем заголовок user-locale
        config.headers['user-locale'] = currentLocale
      }

      return config
    },
    (error) => Promise.reject(error),
  )
}
